<template>
	<table class="player-mrus">
		<tr class="header-row sticky">
			<th>Player</th>
			<th>MRU Name</th>
			<th>MRU Location</th>
			<th>MRU Status</th>
			<th>Cash <span class="in">In</span>/<span class="out">Out</span></th>
			<th>Initiation Date</th>
			<th>Resolution Date</th>
		</tr>
		<tr class="data-row" :class="item.status.toLowerCase()" v-for="(item, index) in allMrus" :key="index">
			<td>{{ selectedUser.displayName }}</td>
			<td>{{ item.mruName }}</td>
			<td>{{ item.mruLocation }}</td>
			<td v-if="item.status === 'Pending'" class="mru-status">
				<button class="btn resolve" title="Click to resolve this pending MRU" @click="resolveMruModal(item)">
					{{ item.status }}
				</button>
			</td>
			<td v-else class="mru-status">{{ item.status }}</td>
			<td
				class="cash-in-out-amount"
				:class="Math.sign(item.fromPlayerCashCOC) === 1 ? 'cash-in' : 'cash-out'"
				:title="Math.sign(item.fromPlayerCashCOC) === 1 ? 'Cash-in transaction' : 'Cash-out transaction'"
			>
				{{ systemCurrencyTool.formatCurrency(item.fromPlayerCashCOC, systemFull) }}
			</td>
			<td>{{ new Date(item.initiationDate).toLocaleTimeString([], this.dateOptions) }}</td>
			<td v-if="item.resolutionDate">{{ new Date(item.resolutionDate).toLocaleTimeString([], this.dateOptions) }}</td>
			<td v-else>Not Resolved</td>
		</tr>
	</table>
	<transition name="fade">
		<component v-bind:is="currentModal" :selectedMru="selectedMru" />
	</transition>
</template>

<script>
import { onBeforeUnmount } from "vue";
import ResolveMru from "@/components/ResolveMru";

export default {
	name: "MruResolutionTable",
	components: {
		ResolveMru,
	},
	props: {
		selectedUser: Object,
		allMrus: Object,
		systemCurrencyTool: Object,
	},
	data() {
		return {
			currentModal: null,
			selectedMru: {},
			systemFull: this.systemCurrencyTool.displayType.full,
		};
	},
	created() {
		let thisInstance = this;
		this.eventBus.on("closeMruResolveModal", () => {
			thisInstance.currentModal = null;
		});
		onBeforeUnmount(() => {
			thisInstance.eventBus.off("closeMruResolveModal");
		});
	},
	methods: {
		resolveMruModal(mru) {
			this.selectedMru = mru;
			this.currentModal = "ResolveMru";
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.player-mrus {
	position: relative;
	width: 100%;
	text-align: left;
	border-collapse: collapse;
}

.player-mrus th,
.player-mrus td {
	border: 1px #000 solid;
	padding: 5px 10px;
}

.mru-status {
	text-align: center;
}

.cash-in-out-amount {
	text-align: right;
}

.cash-out {
	background-color: #00d0ff;
	color: #ad0000;
	font-weight: bold;
	cursor: help;
}

.cash-in {
	background-color: #00ffa1;
	cursor: help;
}

.in {
	color: #00ffa1;
}

.out {
	color: #00d0ff;
}

.resolve {
	font-size: 1em;
}

#mrus-loading {
	display: grid;
	align-content: center;
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background-color: rgb(0 0 0 / 80%);
	color: #fff;
	text-align: center;
	z-index: 200;
}

.player-mrus tr.cancelled {
	background-color: rgb(255 189 69 / 50%) !important;
}

.player-mrus tr.pending {
	background-color: rgb(241 243 113 / 30%) !important;
	color: #000;
}

.loading-icon {
	margin: 0 auto 10px;
}

.player-mrus tr:nth-child(2n) {
	background-color: #bfbfbf;
}
@media (min-width: 768px) {
	#date-filters {
		flex-direction: row;
	}
}
</style>
